<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar v-model="formData" @search="handleSearch"></search-bar>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="table"
          border
          stripe
          :data="tableData"
          :height="tableHeight"
          @sort-change="handleSortChange"
          v-if="tableHeight"
          v-loading="loading"
        >
          <el-table-column label="图片" prop="" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="showDialog(scope.row, 0)" v-if="scope.row.imgUrlList.length">查看</el-link>
              <el-link :underline="false" disabled v-else>查看</el-link>
            </template>
          </el-table-column>
          <el-table-column label="产品编码" prop="productCode" show-overflow-tooltip sortable="custom"></el-table-column>
          <el-table-column label="产品名称" prop="productName" show-overflow-tooltip sortable="custom"></el-table-column>
          <el-table-column label="新品上市时间" prop="marketTime" show-overflow-tooltip align="right" sortable="custom"></el-table-column>
          <el-table-column label="预估量" prop="subMonthPlan" show-overflow-tooltip align="right" sortable="custom"></el-table-column>
          <el-table-column label="预估调整量" prop="subMonthAdjust" show-overflow-tooltip align="right" sortable="custom">
            <template slot-scope="scope">
              <div v-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`">
                <!-- 店铺权限允许修改 -->
                <el-link type="primary"
                  :underline="false"
                  @click="showsubMonthAdjust(scope.row)"
                  v-if="!isAllPlan"
                  v-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`"
                >
                  {{scope.row.subMonthAdjust || 0}}
                </el-link>
                <span v-else>{{scope.row.subMonthAdjust || 0}}</span>
              </div>
              <div v-no-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`">
                {{scope.row.subMonthAdjust||0}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="首批量" prop="firstBatch" show-overflow-tooltip align="right" sortable="custom">
            <template slot-scope="scope">
              <div v-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`">
                <!-- 全平台权限允许修改 -->
                <el-link type="primary"
                  :underline="false"
                  @click="showfirstBatch(scope.row)"
                  v-if="isAllPlan"
                  v-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`"
                >
                  {{scope.row.firstBatch || 0}}
                </el-link>
                <span v-else>{{scope.row.firstBatch || 0}}</span>
              </div>
              <div v-no-permission="`ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$edit adjust`">
                {{scope.row.firstBatch||0}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="累计销量" prop="cumulativeSalesVolume" show-overflow-tooltip align="right" sortable="custom"></el-table-column>
          <el-table-column label="日均销量" prop="averageDailySales" show-overflow-tooltip align="right" sortable="custom"></el-table-column>
          <el-table-column label="可售天数" prop="daysAvailableForSale" show-overflow-tooltip align="right" sortable="custom"></el-table-column>
        </el-table>
        <div style="overflow: hidden;">
          <div style="float: left; margin-top: 15px; color: #555;">
            <span>{{dataUpdateObj.updateContent}}：</span>
            <span>{{dataUpdateObj.latestUpdateTime}}</span>
          </div>
          <el-pagination
            style="float: right; margin-top: 10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
    <!-- 图片&视频 -->
    <pic-video :data="rowData" :detailType="viewType" ref="picVideo"></pic-video>
    <!-- 编辑预估调整量 -->
    <sub-month-adjust v-model="subMonthAdjustVisible" :data="rowData" v-if="subMonthAdjustVisible"></sub-month-adjust>
    <!-- 首批量 -->
    <first-batch v-model="firstBatchVisible" :data="rowData" v-if="firstBatchVisible"></first-batch>
  </div>
</template>

<script>
  import mixin from '@/views/preSalePlan/utils/mixin.js'
  import searchBar from './search'

  import picVideoMixin from './pic&video.mixin'
  import subMonthAdjustMixin from './subMonthAdjust.mixin'
  import firstBatchMixin from './firstBatch.mixin'
  export default {
    mixins: [mixin, picVideoMixin, subMonthAdjustMixin, firstBatchMixin],
    props: ['form', 'dataUpdateObj'],
    components: {
      searchBar
    },
    data() {
      return {
        tableHeight: 0,
        loading: false,
        formData: {},
        tableData: [],
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        },
        // table 升序降序
        descOrAsc: '',
        fieldName: ''
      }
    },
    mounted() {
      this.tableHeight = this.$refs['wrapper'].offsetHeight - 105;
      this.init();
    },
    methods: {
      handleSearch(data,type) {
        if(type == 1) {
          this.descOrAsc = '';
          this.fieldName = '';
          this.$nextTick(_=>{
            this.$refs.table.clearSort()
          })
        }
        this.paginationOpt.pageNum = 1;
        this.formData = data;
        this.init();
      },
      init() {
        this.loading = true;

        this.formData['planTime'] = this.planTime
        this.formData['storeId'] = this.storeId

        let formData = {
          pageSize: this.paginationOpt.pageSize,
          pageNum: this.paginationOpt.pageNum,
          filterData: {
            ...this.formData,
            descOrAsc: this.descOrAsc,
            fieldName: this.fieldName
          }
        };
        this.$q.preSalePlan.newProductResultListPage({data: formData})
        .then(res=>{
          this.tableData = res.data.records;
          this.paginationOpt['total'] = res.data.total;
        })
        .finally(_=>{
          this.loading = false;
        })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      },
      handleSortChange({column, prop, order}) {
        console.log({column, prop, order});
        if(order === null) {
          this.descOrAsc = '';
          this.fieldName = '';
        }
        if(order === 'ascending') {
          this.descOrAsc = '';
          this.fieldName = prop;
        }
        if(order === 'descending'){
          this.descOrAsc = 'desc';
          this.fieldName = prop;
        }
        this.init();
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .container
    width auto 
    height calc(100% - 110px)
    box-sizing border-box
    border-radius 5px
  >>> .el-header
    background #ffffff
    padding 0 8px
    position relative
    border-radius 5px
  >>> .el-main
    padding 5px 8px
    background #ffffff
    border-radius 5px
</style>